import { NavigationRoutes } from 'common/constants';
import { themedStyled } from 'common/styles/styletron.theme';
import HOCInput from 'components/common/hoc-input';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useNavigation from 'hooks/use-navigation';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  OneQuarterContainer,
  SectionContainer as RawSectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function ReleasePurchaseCard() {
  const { t } = useTranslation();
  const { navigate } = useNavigation();

  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <SectionContainer>
        <Text variant="HeadingXSmall">{t('common:refund_detail')}</Text>
        <HOCInput keys={['approvalable']}>
          {(value) => (
            <Button
              buttonType="secondary"
              onClick={() =>
                navigate(NavigationRoutes.RefundReleaseAgentView, {
                  id: value.approvalable.id,
                })
              }
            >
              {t('common:view_old_data')}
            </Button>
          )}
        </HOCInput>
      </SectionContainer>
      <Separator gap={16} />
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.invoiceNumber"
            label={t('common:invoice_number')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.orderNumber"
            label={t('common:number')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="approvalable.requestedAt"
            label={t('refund:requested_at')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.agent"
            label={t('common:agent')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="number"
            name="approvalable.refundAmount"
            label={t('refund:refund_amount')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.reason"
            label={t('refund:refund_reason')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.paymentMethod"
            label={t('common:payment_method')}
          />
        </HalfContainer>
        <HalfContainer>
          <HOCInput keys={['approvalable.paymentMethod']}>
            {(value) => (
              <Input
                type="text"
                name="approvalable.reason"
                label={value['approvalable.paymentMethod']}
              />
            )}
          </HOCInput>
        </HalfContainer>
      </SectionContainer>
      <HOCInput keys={['approvalable.chequeNote']}>
        {(value) => {
          if (!value['approvalable.chequeNote']) return <></>;
          return (
            <>
              <SectionContainer>
                <OneQuarterContainer>
                  <Input
                    type="text"
                    name="approvalable.chequeNote.referenceNumber"
                    label={t('debt:reference_number')}
                  />
                </OneQuarterContainer>
                <OneQuarterContainer>
                  <Input
                    type="date-time"
                    name="approvalable.chequeNote.issuedAt"
                    label={t('debt:issued_at')}
                  />
                </OneQuarterContainer>
                <OneQuarterContainer>
                  <Input
                    type="date-time"
                    name="approvalable.chequeNote.availableAt"
                    label={t('common:available_at')}
                  />
                </OneQuarterContainer>
                <OneQuarterContainer>
                  <Input
                    type="date-time"
                    name="approvalable.chequeNote.expiredAt"
                    label={t('common:expiry_at')}
                  />
                </OneQuarterContainer>
              </SectionContainer>
              <FullContainer>
                <Input
                  type="text"
                  name="approvalable.chequeNote.bankAccount"
                  label={t('common:bank_account')}
                />
              </FullContainer>
            </>
          );
        }}
      </HOCInput>
    </CardSection>
  );
}

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
